import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { parseDateDdMmYyyy } from './date-range.util';

/**
 * Native date adapter whose text parsing only accepts a complete dd/mm/yyyy date.
 *
 * The stock adapter hands typed text to `Date.parse`, so a partial entry such as "1" or "01/01"
 * becomes a 2001 date and is written back into the field mid-typing (and "01/02/2026" is read as
 * 2 January). An incomplete entry is an invalid date here, which the datepicker input treats as
 * "no date yet" without rewriting what the user typed.
 */
@Injectable()
export class DdMmYyyyDateAdapter extends NativeDateAdapter {
  override parse(value: unknown, parseFormat?: unknown): Date | null {
    if (typeof value === 'string') {
      return value.trim() === '' ? null : (parseDateDdMmYyyy(value) ?? this.invalid());
    }
    return super.parse(value, parseFormat);
  }
}
